import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { VFScreen } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import DeviceFullSpecsContainer from '../../Containers/DeviceDetails/Component/DeviceFullSpecsContainer';

class DeviceFullSpecs extends Component {
  render() {
    const { theme, onBack, vfScreen, data } = this.props;
    return (
      <VFScreen
        title="device_upgrade_device_step_show_full_specifications_screen_title"
        showBack
        showClose={false}
        onBack={onBack}
        {...vfScreen}
      >
        <DeviceFullSpecsContainer theme={theme} data={data} />
      </VFScreen>
    );
  }
}

DeviceFullSpecs.defaultProps = {
  vfScreen: {},
};

DeviceFullSpecs.propTypes = {
  onBack: PropTypes.func,
  vfScreen: PropTypes.object,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      values: PropTypes.array.isRequired,
    }),
  ),
};

export default withTheme(DeviceFullSpecs);
